import { PartnerTokenDocs, PartnerTokenMachine } from './PartnerTokenMachine';

import { GenericTypes } from '../../Generic/Types';

const onPartnerToken: GenericTypes = {
  machine: PartnerTokenMachine,
  docs: PartnerTokenDocs,
  order: 1,
};

export default {
  onPartnerToken,
};
